module.exports = __webpack_public_path__ + "static/media/IllyaSlide.6672c29f.jpg";